// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/section-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/DM_Sans/DMSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/DM_Sans/DMSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/DM_Sans/DMSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"] {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield !important;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.navlink-active {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 109 / var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 0.5rem;
  font-size: 18px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.navlink-active:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
@media (min-width: 768px) {

  .navlink-active {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 990px) {

  .navlink-active {
    margin-left: 0px;
    display: block;
    border-right-width: 0px;
    border-bottom-width: 4px;
    --tw-border-opacity: 1;
    border-color: rgb(255 123 109 / var(--tw-border-opacity));
    background-color: transparent;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0px;
  }
}
@media (min-width: 1024px) {

  .navlink-active {
    margin-left: 0.75rem;
  }
}
@media (min-width: 1040px) {

  .navlink-active {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
.navlink-inactive {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 0.5rem;
  font-size: 18px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.navlink-inactive:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
@media (min-width: 768px) {

  .navlink-inactive {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 990px) {

  .navlink-inactive {
    margin-left: 0px;
    display: block;
    border-right-width: 0px;
    background-color: transparent;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0px;
  }
}
@media (min-width: 1024px) {

  .navlink-inactive {
    margin-left: 0.75rem;
  }
}
@media (min-width: 1040px) {

  .navlink-inactive {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
.tw-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.tw-pointer-events-none {
  pointer-events: none;
}
.tw-invisible {
  visibility: hidden;
}
.tw-fixed {
  position: fixed;
}
.tw-absolute {
  position: absolute;
}
.tw-relative {
  position: relative;
}
.tw-inset-0 {
  inset: 0px;
}
.tw-inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-tw-top-4 {
  top: -1rem;
}
.tw-bottom-2 {
  bottom: 0.5rem;
}
.tw-bottom-2\\.5 {
  bottom: 0.625rem;
}
.tw-end-2 {
  inset-inline-end: 0.5rem;
}
.tw-end-2\\.5 {
  inset-inline-end: 0.625rem;
}
.tw-left-2 {
  left: 0.5rem;
}
.tw-left-\\[160px\\] {
  left: 160px;
}
.tw-left-\\[30px\\] {
  left: 30px;
}
.tw-left-\\[50px\\] {
  left: 50px;
}
.tw-right-\\[10px\\] {
  right: 10px;
}
.tw-right-\\[5\\%\\] {
  right: 5%;
}
.tw-start-0 {
  inset-inline-start: 0px;
}
.tw-top-\\[-13px\\] {
  top: -13px;
}
.tw-top-\\[-9\\.375rem\\] {
  top: -9.375rem;
}
.tw-top-\\[100px\\] {
  top: 100px;
}
.tw-top-\\[783\\.48px\\] {
  top: 783.48px;
}
.tw-top-\\[9\\.375rem\\] {
  top: 9.375rem;
}
.tw-z-0 {
  z-index: 0;
}
.tw-z-10 {
  z-index: 10;
}
.tw-z-20 {
  z-index: 20;
}
.tw-z-50 {
  z-index: 50;
}
.tw-m-4 {
  margin: 1rem;
}
.tw-m-5 {
  margin: 1.25rem;
}
.tw-m-auto {
  margin: auto;
}
.tw-mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.tw-mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.tw-mx-24 {
  margin-left: 6rem;
  margin-right: 6rem;
}
.tw-mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.tw-mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.tw-mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.tw-my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.tw-my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.tw-my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.tw-my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.tw-mb-1 {
  margin-bottom: 0.25rem;
}
.tw-mb-2 {
  margin-bottom: 0.5rem;
}
.tw-mb-4 {
  margin-bottom: 1rem;
}
.tw-mb-5 {
  margin-bottom: 1.25rem;
}
.tw-mb-6 {
  margin-bottom: 1.5rem;
}
.tw-mb-8 {
  margin-bottom: 2rem;
}
.tw-ml-0 {
  margin-left: 0px;
}
.tw-ml-1 {
  margin-left: 0.25rem;
}
.tw-ml-12 {
  margin-left: 3rem;
}
.tw-ml-14 {
  margin-left: 3.5rem;
}
.tw-ml-3 {
  margin-left: 0.75rem;
}
.tw-ml-4 {
  margin-left: 1rem;
}
.tw-ml-\\[20\\%\\] {
  margin-left: 20%;
}
.tw-ml-\\[40\\%\\] {
  margin-left: 40%;
}
.tw-ml-auto {
  margin-left: auto;
}
.tw-mr-1 {
  margin-right: 0.25rem;
}
.tw-mr-2 {
  margin-right: 0.5rem;
}
.tw-mt-0 {
  margin-top: 0px;
}
.tw-mt-0\\.5 {
  margin-top: 0.125rem;
}
.tw-mt-1 {
  margin-top: 0.25rem;
}
.tw-mt-10 {
  margin-top: 2.5rem;
}
.tw-mt-12 {
  margin-top: 3rem;
}
.tw-mt-2 {
  margin-top: 0.5rem;
}
.tw-mt-3 {
  margin-top: 0.75rem;
}
.tw-mt-4 {
  margin-top: 1rem;
}
.tw-mt-5 {
  margin-top: 1.25rem;
}
.tw-mt-6 {
  margin-top: 1.5rem;
}
.tw-mt-\\[0\\.25rem\\] {
  margin-top: 0.25rem;
}
.tw-mt-\\[2px\\] {
  margin-top: 2px;
}
.tw-mt-\\[2rem\\] {
  margin-top: 2rem;
}
.tw-block {
  display: block;
}
.tw-inline-block {
  display: inline-block;
}
.tw-flex {
  display: flex;
}
.tw-grid {
  display: grid;
}
.tw-hidden {
  display: none;
}
.tw-h-1 {
  height: 0.25rem;
}
.tw-h-10 {
  height: 2.5rem;
}
.tw-h-12 {
  height: 3rem;
}
.tw-h-14 {
  height: 3.5rem;
}
.tw-h-16 {
  height: 4rem;
}
.tw-h-24 {
  height: 6rem;
}
.tw-h-4 {
  height: 1rem;
}
.tw-h-7 {
  height: 1.75rem;
}
.tw-h-8 {
  height: 2rem;
}
.tw-h-\\[1px\\] {
  height: 1px;
}
.tw-h-\\[200px\\] {
  height: 200px;
}
.tw-h-\\[38px\\] {
  height: 38px;
}
.tw-h-\\[40px\\] {
  height: 40px;
}
.tw-h-\\[42px\\] {
  height: 42px;
}
.tw-h-\\[48px\\] {
  height: 48px;
}
.tw-h-\\[4px\\] {
  height: 4px;
}
.tw-h-\\[50vh\\] {
  height: 50vh;
}
.tw-h-\\[60px\\] {
  height: 60px;
}
.tw-h-\\[90\\%\\] {
  height: 90%;
}
.tw-h-auto {
  height: auto;
}
.tw-h-full {
  height: 100%;
}
.tw-h-screen {
  height: 100vh;
}
.tw-w-1\\/2 {
  width: 50%;
}
.tw-w-14 {
  width: 3.5rem;
}
.tw-w-2 {
  width: 0.5rem;
}
.tw-w-20 {
  width: 5rem;
}
.tw-w-3\\/4 {
  width: 75%;
}
.tw-w-32 {
  width: 8rem;
}
.tw-w-36 {
  width: 9rem;
}
.tw-w-4 {
  width: 1rem;
}
.tw-w-40 {
  width: 10rem;
}
.tw-w-52 {
  width: 13rem;
}
.tw-w-60 {
  width: 15rem;
}
.tw-w-7 {
  width: 1.75rem;
}
.tw-w-8 {
  width: 2rem;
}
.tw-w-80 {
  width: 20rem;
}
.tw-w-9 {
  width: 2.25rem;
}
.tw-w-9\\.5\\/10 {
  width: 95%;
}
.tw-w-9\\/10 {
  width: 90%;
}
.tw-w-\\[100\\%\\] {
  width: 100%;
}
.tw-w-\\[100px\\] {
  width: 100px;
}
.tw-w-\\[116px\\] {
  width: 116px;
}
.tw-w-\\[1200px\\] {
  width: 1200px;
}
.tw-w-\\[15\\%\\] {
  width: 15%;
}
.tw-w-\\[150px\\] {
  width: 150px;
}
.tw-w-\\[154px\\] {
  width: 154px;
}
.tw-w-\\[156px\\] {
  width: 156px;
}
.tw-w-\\[170px\\] {
  width: 170px;
}
.tw-w-\\[1rem\\] {
  width: 1rem;
}
.tw-w-\\[2\\.1875rem\\] {
  width: 2.1875rem;
}
.tw-w-\\[200px\\] {
  width: 200px;
}
.tw-w-\\[25\\%\\] {
  width: 25%;
}
.tw-w-\\[250px\\] {
  width: 250px;
}
.tw-w-\\[30\\%\\] {
  width: 30%;
}
.tw-w-\\[4\\.75rem\\] {
  width: 4.75rem;
}
.tw-w-\\[40px\\] {
  width: 40px;
}
.tw-w-\\[480px\\] {
  width: 480px;
}
.tw-w-\\[5\\%\\] {
  width: 5%;
}
.tw-w-\\[50\\%\\] {
  width: 50%;
}
.tw-w-\\[60px\\] {
  width: 60px;
}
.tw-w-\\[70\\%\\] {
  width: 70%;
}
.tw-w-\\[80\\%\\] {
  width: 80%;
}
.tw-w-\\[85\\%\\] {
  width: 85%;
}
.tw-w-\\[90\\%\\] {
  width: 90%;
}
.tw-w-\\[93\\%\\] {
  width: 93%;
}
.tw-w-\\[95\\%\\] {
  width: 95%;
}
.tw-w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.tw-w-full {
  width: 100%;
}
.tw-w-screen {
  width: 100vw;
}
.tw-min-w-fit {
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.tw-max-w-\\[95\\%\\] {
  max-width: 95%;
}
.tw-flex-1 {
  flex: 1 1;
}
.tw-flex-\\[1\\.5_1\\.5_0\\%\\] {
  flex: 1.5 1.5;
}
.tw-flex-\\[2\\] {
  flex: 2 1;
}
.tw-flex-\\[3\\] {
  flex: 3 1;
}
.tw-rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-spin {

  to {
    transform: rotate(360deg);
  }
}
.tw-animate-spin {
  animation: tw-spin 1s linear infinite;
}
.tw-cursor-pointer {
  cursor: pointer;
}
.tw-list-disc {
  list-style-type: disc;
}
.tw-appearance-none {
  appearance: none;
}
.tw-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.tw-flex-row {
  flex-direction: row;
}
.tw-flex-col {
  flex-direction: column;
}
.tw-flex-wrap {
  flex-wrap: wrap;
}
.tw-place-items-center {
  place-items: center;
}
.tw-items-start {
  align-items: flex-start;
}
.tw-items-center {
  align-items: center;
}
.tw-justify-start {
  justify-content: flex-start;
}
.tw-justify-end {
  justify-content: flex-end;
}
.tw-justify-center {
  justify-content: center;
}
.tw-justify-between {
  justify-content: space-between;
}
.tw-gap-0 {
  gap: 0px;
}
.tw-gap-1 {
  gap: 0.25rem;
}
.tw-gap-10 {
  gap: 2.5rem;
}
.tw-gap-12 {
  gap: 3rem;
}
.tw-gap-16 {
  gap: 4rem;
}
.tw-gap-2 {
  gap: 0.5rem;
}
.tw-gap-3 {
  gap: 0.75rem;
}
.tw-gap-4 {
  gap: 1rem;
}
.tw-gap-5 {
  gap: 1.25rem;
}
.tw-gap-6 {
  gap: 1.5rem;
}
.tw-gap-8 {
  gap: 2rem;
}
.tw-gap-\\[1rem\\] {
  gap: 1rem;
}
.tw-gap-x-2 {
  column-gap: 0.5rem;
}
.tw-gap-x-3 {
  column-gap: 0.75rem;
}
.tw-gap-x-5 {
  column-gap: 1.25rem;
}
.tw-space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.tw-space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.tw-space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.tw-space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.tw-space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.tw-space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.tw-space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.tw-space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.tw-space-y-\\[0\\.5rem\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.tw-self-center {
  align-self: center;
}
.tw-overflow-auto {
  overflow: auto;
}
.tw-overflow-y-auto {
  overflow-y: auto;
}
.tw-overflow-x-hidden {
  overflow-x: hidden;
}
.tw-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tw-break-all {
  word-break: break-all;
}
.tw-rounded {
  border-radius: 0.25rem;
}
.tw-rounded-2xl {
  border-radius: 1rem;
}
.tw-rounded-3xl {
  border-radius: 1.5rem;
}
.tw-rounded-\\[0\\.3125rem\\] {
  border-radius: 0.3125rem;
}
.tw-rounded-\\[0\\.375rem\\] {
  border-radius: 0.375rem;
}
.tw-rounded-\\[0\\.625rem\\] {
  border-radius: 0.625rem;
}
.tw-rounded-\\[1\\.625rem\\] {
  border-radius: 1.625rem;
}
.tw-rounded-\\[1\\.875rem\\] {
  border-radius: 1.875rem;
}
.tw-rounded-\\[1\\.9375rem\\] {
  border-radius: 1.9375rem;
}
.tw-rounded-\\[100\\%\\] {
  border-radius: 100%;
}
.tw-rounded-\\[10px\\] {
  border-radius: 10px;
}
.tw-rounded-\\[1rem\\] {
  border-radius: 1rem;
}
.tw-rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.tw-rounded-full {
  border-radius: 9999px;
}
.tw-rounded-lg {
  border-radius: 0.5rem;
}
.tw-rounded-md {
  border-radius: 0.375rem;
}
.tw-rounded-sm {
  border-radius: 0.125rem;
}
.tw-rounded-xl {
  border-radius: 0.75rem;
}
.tw-rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.tw-rounded-t-\\[2rem\\] {
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.tw-rounded-tr-\\[32px\\] {
  border-top-right-radius: 32px;
}
.tw-border {
  border-width: 1px;
}
.tw-border-2 {
  border-width: 2px;
}
.tw-border-4 {
  border-width: 4px;
}
.tw-border-8 {
  border-width: 8px;
}
.tw-border-\\[0\\.0625rem\\] {
  border-width: 0.0625rem;
}
.tw-border-\\[1px\\] {
  border-width: 1px;
}
.tw-border-\\[2px\\] {
  border-width: 2px;
}
.tw-border-b {
  border-bottom-width: 1px;
}
.tw-border-b-2 {
  border-bottom-width: 2px;
}
.tw-border-r-4 {
  border-right-width: 4px;
}
.tw-border-solid {
  border-style: solid;
}
.tw-border-\\[\\#0B0B0B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(11 11 11 / var(--tw-border-opacity));
}
.tw-border-\\[\\#ABABAB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(171 171 171 / var(--tw-border-opacity));
}
.tw-border-\\[\\#E3E3E3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 227 227 / var(--tw-border-opacity));
}
.tw-border-\\[\\#FF503D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 80 61 / var(--tw-border-opacity));
}
.tw-border-\\[\\#FF7B6D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 123 109 / var(--tw-border-opacity));
}
.tw-border-\\[\\#FF9331\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 147 49 / var(--tw-border-opacity));
}
.tw-border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.tw-border-darkRed {
  --tw-border-opacity: 1;
  border-color: rgb(255 80 61 / var(--tw-border-opacity));
}
.tw-border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.tw-border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.tw-border-intenseRed {
  --tw-border-opacity: 1;
  border-color: rgb(255 67 67 / var(--tw-border-opacity));
}
.tw-border-reddishOrange {
  --tw-border-opacity: 1;
  border-color: rgb(255 123 109 / var(--tw-border-opacity));
}
.tw-border-b-\\[\\#E3E3E3\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(227 227 227 / var(--tw-border-opacity));
}
.tw-border-r-\\[\\#afafaf\\] {
  --tw-border-opacity: 1;
  border-right-color: rgb(175 175 175 / var(--tw-border-opacity));
}
.tw-bg-\\[\\#CCCCCC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 204 204 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#E3E3E3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 227 227 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#EFEFEF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 239 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F7F6F4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 246 244 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#F7F7F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FBD881\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 216 129 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FF503D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 80 61 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FF7B6D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 109 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FFF6F4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 244 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#d7f6ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(215 246 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#f7f7f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#ffddd2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 221 210 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#ffffff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[blue\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 255 / var(--tw-bg-opacity));
}
.tw-bg-\\[transparent\\] {
  background-color: transparent;
}
.tw-bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.tw-bg-darkRed {
  --tw-bg-opacity: 1;
  background-color: rgb(255 80 61 / var(--tw-bg-opacity));
}
.tw-bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.tw-bg-palePink {
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 244 / var(--tw-bg-opacity));
}
.tw-bg-reddishOrange {
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 109 / var(--tw-bg-opacity));
}
.tw-bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.tw-bg-transparent {
  background-color: transparent;
}
.tw-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.tw-bg-\\[url\\(\\'\\/src\\/assets\\/images\\/section-bg\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.tw-bg-auto {
  background-size: auto;
}
.tw-bg-cover {
  background-size: cover;
}
.tw-bg-center {
  background-position: center;
}
.tw-bg-left {
  background-position: left;
}
.tw-bg-no-repeat {
  background-repeat: no-repeat;
}
.tw-fill-darkRed {
  fill: #FF503D;
}
.tw-object-contain {
  object-fit: contain;
}
.tw-object-cover {
  object-fit: cover;
}
.tw-p-0 {
  padding: 0px;
}
.tw-p-0\\.5 {
  padding: 0.125rem;
}
.tw-p-1 {
  padding: 0.25rem;
}
.tw-p-2 {
  padding: 0.5rem;
}
.tw-p-3 {
  padding: 0.75rem;
}
.tw-p-4 {
  padding: 1rem;
}
.tw-p-5 {
  padding: 1.25rem;
}
.tw-p-8 {
  padding: 2rem;
}
.tw-px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.tw-px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.tw-px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.tw-px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.tw-px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw-px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw-px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw-px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.tw-px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.tw-px-\\[0\\.5rem\\] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw-px-\\[10\\%\\] {
  padding-left: 10%;
  padding-right: 10%;
}
.tw-px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.tw-px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.tw-px-\\[3\\%\\] {
  padding-left: 3%;
  padding-right: 3%;
}
.tw-px-\\[35px\\] {
  padding-left: 35px;
  padding-right: 35px;
}
.tw-px-\\[36px\\] {
  padding-left: 36px;
  padding-right: 36px;
}
.tw-px-\\[40px\\] {
  padding-left: 40px;
  padding-right: 40px;
}
.tw-px-\\[5\\%\\] {
  padding-left: 5%;
  padding-right: 5%;
}
.tw-py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.tw-py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.tw-py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw-py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.tw-py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.tw-py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.tw-py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw-py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.tw-py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.tw-py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.tw-py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.tw-py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.tw-py-\\[0\\.25rem\\] {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw-py-\\[0\\.5rem\\] {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-pb-2 {
  padding-bottom: 0.5rem;
}
.tw-pb-3 {
  padding-bottom: 0.75rem;
}
.tw-pb-36 {
  padding-bottom: 9rem;
}
.tw-pb-4 {
  padding-bottom: 1rem;
}
.tw-pb-5 {
  padding-bottom: 1.25rem;
}
.tw-pb-6 {
  padding-bottom: 1.5rem;
}
.tw-pb-\\[30px\\] {
  padding-bottom: 30px;
}
.tw-pl-0 {
  padding-left: 0px;
}
.tw-pl-1 {
  padding-left: 0.25rem;
}
.tw-pl-10 {
  padding-left: 2.5rem;
}
.tw-pl-12 {
  padding-left: 3rem;
}
.tw-pl-2 {
  padding-left: 0.5rem;
}
.tw-pl-4 {
  padding-left: 1rem;
}
.tw-pl-5 {
  padding-left: 1.25rem;
}
.tw-pl-7 {
  padding-left: 1.75rem;
}
.tw-pl-\\[10\\%\\] {
  padding-left: 10%;
}
.tw-pl-\\[1rem\\] {
  padding-left: 1rem;
}
.tw-pl-\\[2rem\\] {
  padding-left: 2rem;
}
.tw-pl-\\[40px\\] {
  padding-left: 40px;
}
.tw-pl-\\[50px\\] {
  padding-left: 50px;
}
.tw-pl-\\[70\\%\\] {
  padding-left: 70%;
}
.tw-pl-\\[8\\%\\] {
  padding-left: 8%;
}
.tw-pr-10 {
  padding-right: 2.5rem;
}
.tw-pr-5 {
  padding-right: 1.25rem;
}
.tw-pr-9 {
  padding-right: 2.25rem;
}
.tw-ps-10 {
  padding-inline-start: 2.5rem;
}
.tw-ps-3 {
  padding-inline-start: 0.75rem;
}
.tw-pt-10 {
  padding-top: 2.5rem;
}
.tw-pt-12 {
  padding-top: 3rem;
}
.tw-pt-2 {
  padding-top: 0.5rem;
}
.tw-pt-3 {
  padding-top: 0.75rem;
}
.tw-pt-4 {
  padding-top: 1rem;
}
.tw-pt-5 {
  padding-top: 1.25rem;
}
.tw-pt-6 {
  padding-top: 1.5rem;
}
.tw-pt-7 {
  padding-top: 1.75rem;
}
.tw-pt-8 {
  padding-top: 2rem;
}
.tw-text-left {
  text-align: left;
}
.tw-text-center {
  text-align: center;
}
.tw-text-right {
  text-align: right;
}
.tw-text-start {
  text-align: start;
}
.tw-text-end {
  text-align: end;
}
.tw-align-middle {
  vertical-align: middle;
}
.tw-text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.tw-text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.tw-text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.tw-text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.tw-text-8xl {
  font-size: 6rem;
  line-height: 1;
}
.tw-text-\\[0\\.44rem\\] {
  font-size: 0.44rem;
}
.tw-text-\\[0\\.625rem\\] {
  font-size: 0.625rem;
}
.tw-text-\\[0\\.705rem\\] {
  font-size: 0.705rem;
}
.tw-text-\\[0\\.75rem\\] {
  font-size: 0.75rem;
}
.tw-text-\\[0\\.7rem\\] {
  font-size: 0.7rem;
}
.tw-text-\\[0\\.875rem\\] {
  font-size: 0.875rem;
}
.tw-text-\\[1\\.125rem\\] {
  font-size: 1.125rem;
}
.tw-text-\\[1\\.25rem\\] {
  font-size: 1.25rem;
}
.tw-text-\\[1\\.2rem\\] {
  font-size: 1.2rem;
}
.tw-text-\\[1\\.625rem\\] {
  font-size: 1.625rem;
}
.tw-text-\\[1\\.725rem\\] {
  font-size: 1.725rem;
}
.tw-text-\\[1\\.95rem\\] {
  font-size: 1.95rem;
}
.tw-text-\\[10px\\] {
  font-size: 10px;
}
.tw-text-\\[11px\\] {
  font-size: 11px;
}
.tw-text-\\[12px\\] {
  font-size: 12px;
}
.tw-text-\\[130px\\] {
  font-size: 130px;
}
.tw-text-\\[13px\\] {
  font-size: 13px;
}
.tw-text-\\[14px\\] {
  font-size: 14px;
}
.tw-text-\\[16px\\] {
  font-size: 16px;
}
.tw-text-\\[18px\\] {
  font-size: 18px;
}
.tw-text-\\[1rem\\] {
  font-size: 1rem;
}
.tw-text-\\[20px\\] {
  font-size: 20px;
}
.tw-text-\\[22px\\] {
  font-size: 22px;
}
.tw-text-\\[24px\\] {
  font-size: 24px;
}
.tw-text-\\[26px\\] {
  font-size: 26px;
}
.tw-text-\\[28px\\] {
  font-size: 28px;
}
.tw-text-\\[30px\\] {
  font-size: 30px;
}
.tw-text-\\[36px\\] {
  font-size: 36px;
}
.tw-text-\\[40px\\] {
  font-size: 40px;
}
.tw-text-\\[46px\\] {
  font-size: 46px;
}
.tw-text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.tw-text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw-text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw-text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw-text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.tw-font-\\[700\\] {
  font-weight: 700;
}
.tw-font-\\[900\\] {
  font-weight: 900;
}
.tw-font-bold {
  font-weight: 700;
}
.tw-font-light {
  font-weight: 300;
}
.tw-font-medium {
  font-weight: 500;
}
.tw-font-normal {
  font-weight: 400;
}
.tw-font-semibold {
  font-weight: 600;
}
.tw-uppercase {
  text-transform: uppercase;
}
.tw-capitalize {
  text-transform: capitalize;
}
.tw-italic {
  font-style: italic;
}
.tw-leading-5 {
  line-height: 1.25rem;
}
.tw-leading-\\[1\\.625rem\\] {
  line-height: 1.625rem;
}
.tw-leading-\\[1\\.9375rem\\] {
  line-height: 1.9375rem;
}
.tw-tracking-wider {
  letter-spacing: 0.05em;
}
.tw-text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-\\[\\#29223E\\] {
  --tw-text-opacity: 1;
  color: rgb(41 34 62 / var(--tw-text-opacity));
}
.tw-text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}
.tw-text-\\[\\#6C6C6C\\] {
  --tw-text-opacity: 1;
  color: rgb(108 108 108 / var(--tw-text-opacity));
}
.tw-text-\\[\\#8750A4\\] {
  --tw-text-opacity: 1;
  color: rgb(135 80 164 / var(--tw-text-opacity));
}
.tw-text-\\[\\#ABABAB\\] {
  --tw-text-opacity: 1;
  color: rgb(171 171 171 / var(--tw-text-opacity));
}
.tw-text-\\[\\#FF7B6D\\] {
  --tw-text-opacity: 1;
  color: rgb(255 123 109 / var(--tw-text-opacity));
}
.tw-text-\\[\\#FFFFFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-text-\\[rgb\\(0\\,0\\,0\\)\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.tw-text-darkPurple {
  --tw-text-opacity: 1;
  color: rgb(41 34 62 / var(--tw-text-opacity));
}
.tw-text-darkRed {
  --tw-text-opacity: 1;
  color: rgb(255 80 61 / var(--tw-text-opacity));
}
.tw-text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.tw-text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.tw-text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.tw-text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.tw-text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.tw-text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.tw-text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.tw-text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
.tw-text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.tw-text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.tw-text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.tw-text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.tw-text-reddishOrange {
  --tw-text-opacity: 1;
  color: rgb(255 123 109 / var(--tw-text-opacity));
}
.tw-text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-underline {
  text-decoration-line: underline;
}
.tw-placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.tw-accent-reddishOrange {
  accent-color: #FF7B6D;
}
.tw-opacity-0 {
  opacity: 0;
}
.tw-opacity-100 {
  opacity: 1;
}
.tw-opacity-50 {
  opacity: 0.5;
}
.tw-opacity-60 {
  opacity: 0.6;
}
.tw-shadow-3xl {
  --tw-shadow:  6px 6px 8px rgba(134, 79, 163, 0.1);
  --tw-shadow-colored: 6px 6px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-small {
  --tw-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0px 4px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.no-scrollbar::-webkit-scrollbar {
    display: none;
  }
.scroll_n {
    overflow-y: none;
  }
.no-scrollbar {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }

@font-face {
  font-family: "DMSans-Regular";
  src: local("DMSans-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
}

@font-face {
  font-family: "DMSansMedium";
  src: local("DMSansMedium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
}

/* @font-face {
  font-family: 'TenonXLight';
  src: local('TenonXLight'),
    url('./assets/fonts/Fontspring-DEMO-tenon-xlight.otf') format('truetype');
  font-weight: normal;
} */

@font-face {
  font-family: "DMSans-Bold";
  src: local("DMSans-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
}

:root {
  --oc-primary-bg: #29223d;
  --oc-primary-color: #ff7b6d;
  --oc-primary-text: #29223e;
  --oc-secondary-text: #6c6c6c;
}

body {
  box-sizing: border-box;
  margin: 0;
  font-family: "DMSans-Regular", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.hover\\:tw-cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:tw-border-darkRed:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 80 61 / var(--tw-border-opacity));
}

.hover\\:tw-border-slate-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}

.hover\\:tw-bg-\\[\\#FF7B6D\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 109 / var(--tw-bg-opacity));
}

.hover\\:tw-bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}

.hover\\:tw-bg-darkRed:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 80 61 / var(--tw-bg-opacity));
}

.hover\\:tw-bg-reddishOrange:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 109 / var(--tw-bg-opacity));
}

.hover\\:tw-bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}

.hover\\:tw-text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.hover\\:tw-text-emerald-50:hover {
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / var(--tw-text-opacity));
}

.hover\\:tw-text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.hover\\:tw-text-reddishOrange:hover {
  --tw-text-opacity: 1;
  color: rgb(255 123 109 / var(--tw-text-opacity));
}

.hover\\:tw-text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:tw-underline:hover {
  text-decoration-line: underline;
}

.focus\\:tw-bg-reddishOrange:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 109 / var(--tw-bg-opacity));
}

.focus\\:\\!tw-text-reddishOrange:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(255 123 109 / var(--tw-text-opacity)) !important;
}

.focus\\:tw-text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.focus\\:tw-outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:tw-ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:tw-ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
}

@media (prefers-color-scheme: dark) {

  .dark\\:tw-bg-blue-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
  }

  .dark\\:tw-text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }

  .dark\\:tw-text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }

  .dark\\:tw-placeholder-gray-400::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgb(156 163 175 / var(--tw-placeholder-opacity));
  }

  .dark\\:hover\\:tw-bg-blue-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity));
  }

  .dark\\:focus\\:tw-ring-blue-800:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity));
  }
}

@media (min-width: 375px) {

  .min-\\[375px\\]\\:tw-ml-5 {
    margin-left: 1.25rem;
  }

  .min-\\[375px\\]\\:tw-mt-0 {
    margin-top: 0px;
  }

  .min-\\[375px\\]\\:tw-w-auto {
    width: auto;
  }

  .min-\\[375px\\]\\:tw-flex-row {
    flex-direction: row;
  }
}

@media (min-width: 550px) {

  .min-\\[550px\\]\\:tw-gap-2 {
    gap: 0.5rem;
  }
}

@media (min-width: 640px) {

  .sm\\:tw-right-\\[90px\\] {
    right: 90px;
  }

  .sm\\:tw-m-12 {
    margin: 3rem;
  }

  .sm\\:tw-mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:tw-mr-7 {
    margin-right: 1.75rem;
  }

  .sm\\:tw-mt-0 {
    margin-top: 0px;
  }

  .sm\\:tw-h-\\[48px\\] {
    height: 48px;
  }

  .sm\\:tw-w-1\\/2 {
    width: 50%;
  }

  .sm\\:tw-w-9\\/12 {
    width: 75%;
  }

  .sm\\:tw-w-96 {
    width: 24rem;
  }

  .sm\\:tw-w-\\[116px\\] {
    width: 116px;
  }

  .sm\\:tw-flex-row {
    flex-direction: row;
  }

  .sm\\:tw-place-content-center {
    place-content: center;
  }

  .sm\\:tw-justify-center {
    justify-content: center;
  }

  .sm\\:tw-gap-6 {
    gap: 1.5rem;
  }

  .sm\\:tw-p-10 {
    padding: 2.5rem;
  }

  .sm\\:tw-p-3 {
    padding: 0.75rem;
  }

  .sm\\:tw-p-5 {
    padding: 1.25rem;
  }

  .sm\\:tw-px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:tw-px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:tw-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:tw-px-\\[1\\.25rem\\] {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:tw-px-\\[40px\\] {
    padding-left: 40px;
    padding-right: 40px;
  }

  .sm\\:tw-py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:tw-pl-12 {
    padding-left: 3rem;
  }

  .sm\\:tw-pl-\\[10\\%\\] {
    padding-left: 10%;
  }

  .sm\\:tw-pt-8 {
    padding-top: 2rem;
  }

  .sm\\:tw-text-\\[1\\.125rem\\] {
    font-size: 1.125rem;
  }

  .sm\\:tw-text-\\[1rem\\] {
    font-size: 1rem;
  }

  .sm\\:tw-text-\\[20px\\] {
    font-size: 20px;
  }

  .sm\\:tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 768px) {

  .md\\:tw-top-\\[50px\\] {
    top: 50px;
  }

  .md\\:tw-mr-0 {
    margin-right: 0px;
  }

  .md\\:tw-block {
    display: block;
  }

  .md\\:tw-inline-block {
    display: inline-block;
  }

  .md\\:tw-flex {
    display: flex;
  }

  .md\\:tw-hidden {
    display: none;
  }

  .md\\:tw-h-full {
    height: 100%;
  }

  .md\\:tw-w-10\\/12 {
    width: 83.333333%;
  }

  .md\\:tw-w-9\\/10 {
    width: 90%;
  }

  .md\\:tw-w-\\[33\\%\\] {
    width: 33%;
  }

  .md\\:tw-w-auto {
    width: auto;
  }

  .md\\:tw-w-full {
    width: 100%;
  }

  .md\\:tw-flex-1 {
    flex: 1 1;
  }

  .md\\:tw-flex-row {
    flex-direction: row;
  }

  .md\\:tw-place-content-center {
    place-content: center;
  }

  .md\\:tw-items-center {
    align-items: center;
  }

  .md\\:tw-justify-between {
    justify-content: space-between;
  }

  .md\\:tw-gap-12 {
    gap: 3rem;
  }

  .md\\:tw-gap-6 {
    gap: 1.5rem;
  }

  .md\\:tw-space-x-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:tw-overflow-x-auto {
    overflow-x: auto;
  }

  .md\\:tw-rounded-\\[0\\.625rem\\] {
    border-radius: 0.625rem;
  }

  .md\\:tw-rounded-r-\\[30px\\] {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  .md\\:tw-border-2 {
    border-width: 2px;
  }

  .md\\:tw-p-12 {
    padding: 3rem;
  }

  .md\\:tw-px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:tw-px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:tw-px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:tw-px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:tw-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:tw-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:tw-px-\\[1\\.05rem\\] {
    padding-left: 1.05rem;
    padding-right: 1.05rem;
  }

  .md\\:tw-px-\\[1\\.25rem\\] {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:tw-py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:tw-py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:tw-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:tw-py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:tw-py-\\[0\\.5rem\\] {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:tw-pl-14 {
    padding-left: 3.5rem;
  }

  .md\\:tw-pt-14 {
    padding-top: 3.5rem;
  }

  .md\\:tw-text-left {
    text-align: left;
  }

  .md\\:tw-text-center {
    text-align: center;
  }

  .md\\:tw-text-\\[1\\.125rem\\] {
    font-size: 1.125rem;
  }

  .md\\:tw-text-\\[1\\.325rem\\] {
    font-size: 1.325rem;
  }

  .md\\:tw-text-\\[2\\.925rem\\] {
    font-size: 2.925rem;
  }

  .md\\:tw-text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:tw-text-\\[22px\\] {
    font-size: 22px;
  }

  .md\\:tw-text-\\[26px\\] {
    font-size: 26px;
  }

  .md\\:tw-text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 990px) {

  .min-\\[990px\\]\\:tw-block {
    display: block;
  }

  .min-\\[990px\\]\\:tw-hidden {
    display: none;
  }
}

@media (min-width: 992px) {

  .min-\\[992px\\]\\:tw-block {
    display: block;
  }
}

@media (min-width: 1024px) {

  .lg\\:tw-absolute {
    position: absolute;
  }

  .lg\\:tw-left-\\[30\\%\\] {
    left: 30%;
  }

  .lg\\:tw-left-\\[60px\\] {
    left: 60px;
  }

  .lg\\:tw-m-5 {
    margin: 1.25rem;
  }

  .lg\\:tw-mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .lg\\:tw-mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .lg\\:tw-mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .lg\\:tw-mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:tw-my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .lg\\:tw-my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:tw-ml-14 {
    margin-left: 3.5rem;
  }

  .lg\\:tw-ml-5 {
    margin-left: 1.25rem;
  }

  .lg\\:tw-ml-\\[-2rem\\] {
    margin-left: -2rem;
  }

  .lg\\:tw-mr-5 {
    margin-right: 1.25rem;
  }

  .lg\\:tw-mt-0 {
    margin-top: 0px;
  }

  .lg\\:tw-mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:tw-block {
    display: block;
  }

  .lg\\:tw-flex {
    display: flex;
  }

  .lg\\:tw-h-20 {
    height: 5rem;
  }

  .lg\\:tw-h-8 {
    height: 2rem;
  }

  .lg\\:tw-h-\\[300px\\] {
    height: 300px;
  }

  .lg\\:tw-h-\\[4px\\] {
    height: 4px;
  }

  .lg\\:tw-h-full {
    height: 100%;
  }

  .lg\\:tw-w-1\\/2 {
    width: 50%;
  }

  .lg\\:tw-w-1\\/4 {
    width: 25%;
  }

  .lg\\:tw-w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:tw-w-20 {
    width: 5rem;
  }

  .lg\\:tw-w-8 {
    width: 2rem;
  }

  .lg\\:tw-w-80 {
    width: 20rem;
  }

  .lg\\:tw-w-\\[11\\%\\] {
    width: 11%;
  }

  .lg\\:tw-w-\\[13\\%\\] {
    width: 13%;
  }

  .lg\\:tw-w-\\[200px\\] {
    width: 200px;
  }

  .lg\\:tw-w-\\[300px\\] {
    width: 300px;
  }

  .lg\\:tw-w-\\[38\\%\\] {
    width: 38%;
  }

  .lg\\:tw-w-\\[4\\.75rem\\] {
    width: 4.75rem;
  }

  .lg\\:tw-w-\\[40\\%\\] {
    width: 40%;
  }

  .lg\\:tw-w-\\[50\\%\\] {
    width: 50%;
  }

  .lg\\:tw-w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:tw-w-\\[70\\%\\] {
    width: 70%;
  }

  .lg\\:tw-w-\\[90\\%\\] {
    width: 90%;
  }

  .lg\\:tw-w-\\[95\\%\\] {
    width: 95%;
  }

  .lg\\:tw-w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }

  .lg\\:tw-w-full {
    width: 100%;
  }

  .lg\\:tw-flex-row {
    flex-direction: row;
  }

  .lg\\:tw-flex-col {
    flex-direction: column;
  }

  .lg\\:tw-place-content-start {
    place-content: start;
  }

  .lg\\:tw-items-start {
    align-items: flex-start;
  }

  .lg\\:tw-items-end {
    align-items: flex-end;
  }

  .lg\\:tw-items-center {
    align-items: center;
  }

  .lg\\:tw-justify-start {
    justify-content: flex-start;
  }

  .lg\\:tw-justify-center {
    justify-content: center;
  }

  .lg\\:tw-justify-between {
    justify-content: space-between;
  }

  .lg\\:tw-gap-0 {
    gap: 0px;
  }

  .lg\\:tw-gap-12 {
    gap: 3rem;
  }

  .lg\\:tw-gap-16 {
    gap: 4rem;
  }

  .lg\\:tw-gap-20 {
    gap: 5rem;
  }

  .lg\\:tw-gap-5 {
    gap: 1.25rem;
  }

  .lg\\:tw-gap-8 {
    gap: 2rem;
  }

  .lg\\:tw-space-x-24 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(6rem * var(--tw-space-x-reverse));
    margin-left: calc(6rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:tw-self-start {
    align-self: flex-start;
  }

  .lg\\:tw-rounded-\\[1\\.25rem\\] {
    border-radius: 1.25rem;
  }

  .lg\\:tw-rounded-full {
    border-radius: 9999px;
  }

  .lg\\:tw-rounded-r-\\[30px\\] {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  .lg\\:tw-rounded-tr-\\[32px\\] {
    border-top-right-radius: 32px;
  }

  .lg\\:tw-border-2 {
    border-width: 2px;
  }

  .lg\\:tw-border-\\[0\\.1875rem\\] {
    border-width: 0.1875rem;
  }

  .lg\\:tw-border-\\[2px\\] {
    border-width: 2px;
  }

  .lg\\:tw-bg-cover {
    background-size: cover;
  }

  .lg\\:tw-bg-center {
    background-position: center;
  }

  .lg\\:tw-p-10 {
    padding: 2.5rem;
  }

  .lg\\:tw-p-2 {
    padding: 0.5rem;
  }

  .lg\\:tw-p-3 {
    padding: 0.75rem;
  }

  .lg\\:tw-p-5 {
    padding: 1.25rem;
  }

  .lg\\:tw-px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:tw-px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .lg\\:tw-px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:tw-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:tw-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:tw-px-\\[12\\%\\] {
    padding-left: 12%;
    padding-right: 12%;
  }

  .lg\\:tw-px-\\[19\\%\\] {
    padding-left: 19%;
    padding-right: 19%;
  }

  .lg\\:tw-px-\\[20\\%\\] {
    padding-left: 20%;
    padding-right: 20%;
  }

  .lg\\:tw-py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:tw-py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .lg\\:tw-py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:tw-py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:tw-py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:tw-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:tw-py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:tw-py-\\[98px\\] {
    padding-top: 98px;
    padding-bottom: 98px;
  }

  .lg\\:tw-pb-36 {
    padding-bottom: 9rem;
  }

  .lg\\:tw-pl-14 {
    padding-left: 3.5rem;
  }

  .lg\\:tw-pl-2 {
    padding-left: 0.5rem;
  }

  .lg\\:tw-pl-9 {
    padding-left: 2.25rem;
  }

  .lg\\:tw-pl-\\[2\\.3125rem\\] {
    padding-left: 2.3125rem;
  }

  .lg\\:tw-pl-\\[3\\.5rem\\] {
    padding-left: 3.5rem;
  }

  .lg\\:tw-pt-0 {
    padding-top: 0px;
  }

  .lg\\:tw-pt-10 {
    padding-top: 2.5rem;
  }

  .lg\\:tw-pt-7 {
    padding-top: 1.75rem;
  }

  .lg\\:tw-text-left {
    text-align: left;
  }

  .lg\\:tw-text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:tw-text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:tw-text-\\[0\\.875rem\\] {
    font-size: 0.875rem;
  }

  .lg\\:tw-text-\\[1\\.125rem\\] {
    font-size: 1.125rem;
  }

  .lg\\:tw-text-\\[1\\.25rem\\] {
    font-size: 1.25rem;
  }

  .lg\\:tw-text-\\[1\\.375rem\\] {
    font-size: 1.375rem;
  }

  .lg\\:tw-text-\\[1\\.625rem\\] {
    font-size: 1.625rem;
  }

  .lg\\:tw-text-\\[1rem\\] {
    font-size: 1rem;
  }

  .lg\\:tw-text-\\[2\\.25rem\\] {
    font-size: 2.25rem;
  }

  .lg\\:tw-text-\\[20px\\] {
    font-size: 20px;
  }

  .lg\\:tw-text-\\[3\\.425rem\\] {
    font-size: 3.425rem;
  }

  .lg\\:tw-text-\\[3\\.925rem\\] {
    font-size: 3.925rem;
  }

  .lg\\:tw-text-\\[32px\\] {
    font-size: 32px;
  }

  .lg\\:tw-text-\\[35px\\] {
    font-size: 35px;
  }

  .lg\\:tw-text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:tw-text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:tw-font-bold {
    font-weight: 700;
  }

  .lg\\:tw-font-normal {
    font-weight: 400;
  }

  .lg\\:tw-leading-6 {
    line-height: 1.5rem;
  }

  .lg\\:tw-leading-\\[1\\.5rem\\] {
    line-height: 1.5rem;
  }

  .lg\\:tw-leading-\\[1\\.625rem\\] {
    line-height: 1.625rem;
  }

  .lg\\:tw-leading-\\[2\\.6875rem\\] {
    line-height: 2.6875rem;
  }

  .lg\\:tw-shadow-large {
    --tw-shadow: 0px 19px 40px rgba(0, 0, 0, 0.05);
    --tw-shadow-colored: 0px 19px 40px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1280px) {

  .xl\\:tw-top-\\[100px\\] {
    top: 100px;
  }

  .xl\\:tw-w-\\[9\\%\\] {
    width: 9%;
  }

  .xl\\:tw-gap-5 {
    gap: 1.25rem;
  }

  .xl\\:tw-px-\\[18\\%\\] {
    padding-left: 18%;
    padding-right: 18%;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:tw-mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .\\32xl\\:tw-px-\\[40px\\] {
    padding-left: 40px;
    padding-right: 40px;
  }

  .\\32xl\\:tw-text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;EAAd;;;IAAA,wBAAc;IAAd,SAAc;IAAd,qCAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAmEV;EAAA,gCAAoW;EAApW,mCAAoW;EAApW,kBAAoW;EAApW,yDAAoW;EAApW,oBAAoW;EAApW,uBAAoW;EAApW,oBAAoW;EAApW,eAAoW;EAApW,oBAAoW;EAApW;AAAoW;AAApW;EAAA,oBAAoW;EAApW;AAAoW;AAApW;;EAAA;IAAA,kBAAoW;IAApW;EAAoW;AAAA;AAApW;;EAAA;IAAA,gBAAoW;IAApW,cAAoW;IAApW,uBAAoW;IAApW,wBAAoW;IAApW,sBAAoW;IAApW,yDAAoW;IAApW,6BAAoW;IAApW,kBAAoW;IAApW,mBAAoW;IAApW;EAAoW;AAAA;AAApW;;EAAA;IAAA;EAAoW;AAAA;AAApW;;EAAA;IAAA,iBAAoW;IAApW;EAAoW;AAAA;AAIpW;EAAA,oBAAkQ;EAAlQ,uBAAkQ;EAAlQ,oBAAkQ;EAAlQ,eAAkQ;EAAlQ,oBAAkQ;EAAlQ;AAAkQ;AAAlQ;EAAA,oBAAkQ;EAAlQ;AAAkQ;AAAlQ;;EAAA;IAAA,kBAAkQ;IAAlQ;EAAkQ;AAAA;AAAlQ;;EAAA;IAAA,gBAAkQ;IAAlQ,cAAkQ;IAAlQ,uBAAkQ;IAAlQ,6BAAkQ;IAAlQ,kBAAkQ;IAAlQ,mBAAkQ;IAAlQ;EAAkQ;AAAA;AAAlQ;;EAAA;IAAA;EAAkQ;AAAA;AAAlQ;;EAAA;IAAA,iBAAkQ;IAAlQ;EAAkQ;AAAA;AArEtQ;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AA0EjB;IACE,aAAa;EACf;AAEA;IACE,gBAAgB;EAClB;AAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;AArFF;EACE,6BAA6B;EAC7B;8DACqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B;8DACoE;EACpE,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,0BAA0B;EAC1B;8DACkE;EAClE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT;;gCAE8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AApDA;EAAA;AA0FC;;AA1FD;EAAA,sBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,sBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,kBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,kBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,kBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,kBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,kBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;EAAA;AA0FC;;AA1FD;EAAA,kBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,+BA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;EAAA,8BA0FC;EA1FD;AA0FC;;AA1FD;EAAA,2GA0FC;EA1FD,yGA0FC;EA1FD;AA0FC;;AA1FD;EAAA,oBA0FC;EA1FD;AA0FC;;AA1FD;;EAAA;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,2BA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,uBA0FC;IA1FD,mDA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,6BA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,gBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,uBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,uBA0FC;IA1FD,oDA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,6BA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,qBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,oBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,eA0FC;IA1FD;EA0FC;;EA1FD;IAAA,mBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,8CA0FC;IA1FD,yDA0FC;IA1FD;EA0FC;AAAA;;AA1FD;;EAAA;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;AAAA;;AA1FD;;EAAA;IAAA,iBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,kBA0FC;IA1FD;EA0FC;;EA1FD;IAAA,iBA0FC;IA1FD;EA0FC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: \"DMSans-Regular\";\n  src: local(\"DMSans-Regular\"),\n    url(\"./assets/fonts/DM_Sans/DMSans-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: \"DMSansMedium\";\n  src: local(\"DMSansMedium\"),\n    url(\"./assets/fonts/DM_Sans/DMSans-Medium.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n\n/* @font-face {\n  font-family: 'TenonXLight';\n  src: local('TenonXLight'),\n    url('./assets/fonts/Fontspring-DEMO-tenon-xlight.otf') format('truetype');\n  font-weight: normal;\n} */\n\n@font-face {\n  font-family: \"DMSans-Bold\";\n  src: local(\"DMSans-Bold\"),\n    url(\"./assets/fonts/DM_Sans/DMSans-Bold.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n\n:root {\n  --oc-primary-bg: #29223d;\n  --oc-primary-color: #ff7b6d;\n  --oc-primary-text: #29223e;\n  --oc-secondary-text: #6c6c6c;\n}\n\nbody {\n  box-sizing: border-box;\n  margin: 0;\n  font-family: \"DMSans-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n@layer base {\n\n  input[type=\"number\"]::-webkit-outer-spin-button,\n  input[type=\"number\"]::-webkit-inner-spin-button,\n  input[type=\"number\"] {\n    -webkit-appearance: none;\n    margin: 0;\n    -moz-appearance: textfield !important;\n  }\n}\n\n@layer components {\n  .navlink-active {\n    @apply tw-text-white tw-pl-2 tw-py-3 lg:tw-ml-3 min-[990px]:tw-pt-0 min-[990px]:tw-ml-0 tw-bg-reddishOrange tw-rounded-r-xl min-[990px]:tw-bg-transparent min-[990px]:tw-border-r-0 min-[990px]:tw-block min-[990px]:tw-border-b-4 min-[990px]:tw-border-reddishOrange tw-text-[18px] md:tw-text-xl min-[1040px]:tw-text-2xl min-[990px]:tw-px-4 hover:tw-text-white;\n  }\n\n  .navlink-inactive {\n    @apply tw-text-white tw-pl-2 tw-py-3 lg:tw-ml-3 min-[990px]:tw-pt-0 min-[990px]:tw-ml-0 min-[990px]:tw-bg-transparent min-[990px]:tw-border-r-0 min-[990px]:tw-block tw-text-[18px] md:tw-text-xl min-[1040px]:tw-text-2xl min-[990px]:tw-px-4 hover:tw-text-white;\n  }\n}\n\n@layer utilities {\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n\n  .scroll_n {\n    overflow-y: none;\n  }\n\n  .no-scrollbar {\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
